var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1625 21.7125L27.7875 18.3375C27.3375 17.8875 26.6625 17.8875 26.2125 18.3375L15.75 28.8V33.75H20.7L31.1625 23.2875C31.6125 22.8375 31.6125 22.1625 31.1625 21.7125ZM19.8 31.5H18V29.7L23.625 24.075L25.425 25.875L19.8 31.5ZM27 24.3L25.2 22.5L27 20.7L28.8 22.5L27 24.3ZM9 25.875H11.25V28.125H9V25.875ZM13.5 20.25H18V22.5H13.5V20.25ZM9 20.25H11.25V22.5H9V20.25ZM13.5 14.625H22.5V16.875H13.5V14.625ZM9 14.625H11.25V16.875H9V14.625Z",
    fill: "#8FABB8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 31.5V7.875H9V11.25H22.5V7.875H25.875V14.625H28.125V7.875C28.125 6.6375 27.1125 5.625 25.875 5.625H22.5V4.5C22.5 3.2625 21.4875 2.25 20.25 2.25H11.25C10.0125 2.25 9 3.2625 9 4.5V5.625H5.625C4.3875 5.625 3.375 6.6375 3.375 7.875V31.5C3.375 32.7375 4.3875 33.75 5.625 33.75H11.25V31.5H5.625ZM11.25 4.5H20.25V9H11.25V4.5Z",
    fill: "#8FABB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraft);
export default __webpack_public_path__ + "static/media/Draft.a1ac2c35f495027489124b92f2d4d4f4.svg";
export { ForwardRef as ReactComponent };